import React from "react";

const Tab = ({ selectedAmountType, handleAmountType, tabs }) => {
  return (
    <div className="text-base max-sm:text-sm border border-primary w-fit flex rounded-[60px] p-0.5">
      {tabs?.map((tab) => {
        return (
          <div
            onClick={() => handleAmountType(tab?.key)}
            className={`w-40 h-11   max-sm:w-24 max-sm:h-9 cursor-pointer flex justify-center items-center rounded-[60px] ${
              selectedAmountType === tab?.key
                ? "bg-primary text-white font-medium"
                : "text-primary font-normal"
            }`}
          >
            <p>{tab?.title}</p>
          </div>
        );
      })}
    </div>
  );
};

export default Tab;
